import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import FormPreStockInspection from './component/FormPreStockInspection';
import usePreStockInspectionData from '../hook/usePreStockInspectionData';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const PreStockInspectionCreateEdit = () => {
    const { id } = useParams();
    const { th } = useLanguage();
    const initialState = {
        vin: '',
        inspectorName: '',
        inspectorTitle: '',
        notesOrOtherDamages: '',
        stockInDate: '',
        inspectionDate: ''
    };

    const { savePreStockInspection } = usePreStockInspectionData();
    // Form state
    const [formData, setFormData] = useState(initialState);
    const [submitted, setSubmitted] = useState(false);

    const resetForm = useCallback(() => {
        setFormData(initialState);
        setSubmitted(false);
    }, []);

    const handleChange = useCallback((key, value) => {
        setFormData((prev) => ({
            ...prev,
            [key]: value
        }));
    }, []);

    return (
        <div className="card">
            <h2>{id ? th('warranty.preStockInspection.form.editTitle') : th('warranty.preStockInspection.form.addTitle')}</h2>
            <FormPreStockInspection
                editMode={!!id}
                id={id}
                submitted={submitted}
                formData={formData}
                handleChange={handleChange}
                setFormData={setFormData}
                savePreStockInspection={savePreStockInspection}
                resetForm={resetForm}
                setSubmitted={setSubmitted}
            />
        </div>
    );
};

export default PreStockInspectionCreateEdit;
